export default function TextInput({ label, name, placeholder, optional, value, onChange, validationError, canModifyDetails, type, ...rest }) {
    let selectInputClassNames = 'esc-ii-border esc-ii-border-secondary placeholder:esc-ii-text-charcoal placeholder:esc-ii-font-montserrat esc-ii-rounded esc-ii-py-4 esc-ii-px-3 esc-ii-font-montserrat esc-ii-text-base focus:esc-ii-outline-none focus:esc-ii-ring-primary focus:esc-ii-border-primary';
    if (type === 'date') {
        selectInputClassNames += ' esc-font-light';
    }

    return (
        <div className="esc-ii-flex esc-ii-flex-col">
            <label htmlFor={`#` + name} className="esc-ii-mb-3">
                <span className="esc-ii-uppercase esc-ii-font-bold esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs">
                    {label}
                </span>
                {optional && <span className="esc-ii-ml-2 esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs">(Optional)</span>}
            </label>
            {canModifyDetails ? (
                <input
                    type={type}
                    className={selectInputClassNames}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    autoComplete="new-password"
                    isp_ignore
                    {...rest}
                />
            ) : (
                <p className="esc-ii-font-montserrat esc-ii-text-base lg:esc-ii-text-lg">{value}</p>
            )}
            {validationError && (
                <p className="esc-ii-font-montserrat esc-ii-text-[10px] lg:esc-ii-text-xs esc-ii-text-red-600 esc-ii-mt-2">{validationError}</p>
            )}
        </div>
    );
}
